import useEffect from '@/util/hook/useEffect';
import useState from '@/util/hook/useState';
export const usePageHeight = () => {
    const [pageHeight, setPageHeight] = useState(window.innerHeight);
    useEffect(() => {
        const resizeListener = () => {
            setPageHeight(window.innerHeight);
        };
        window.addEventListener('resize', resizeListener);
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);
    return { pageHeight };
};
